const EDIT_APP_QNA_DRAFT_PREFIX = 'admin:appQnaDraft:edit:'

const getSessionStorage = () => {
    if (typeof window === 'undefined') {
        return null
    }

    return window.sessionStorage
}

const normalizeReplyValue = (value) => {
    if (value === undefined || value === null) {
        return ''
    }

    return String(value)
}

// App 문의 상세는 운영자가 다시 작성해야 하는 답변 값만 sessionStorage에 남긴다.
export const createAppQnaDraftPayload = ({ params = {} } = {}) => {
    return {
        params: {
            reply: normalizeReplyValue(params.reply),
        }
    }
}

// 서버 기본값 위에 draft만 덮어써서 새로고침 뒤에도 답변 작성 흐름을 이어간다.
export const applyAppQnaDraft = ({ baseParams = {}, draft }) => {
    if (!draft) {
        return {
            params: {
                ...baseParams,
                reply: normalizeReplyValue(baseParams.reply),
            },
        }
    }

    const draftParams = draft.params || {}

    return {
        params: {
            ...baseParams,
            reply: draftParams.reply === undefined
                ? normalizeReplyValue(baseParams.reply)
                : normalizeReplyValue(draftParams.reply),
        }
    }
}

export const createEditAppQnaDraftKey = (qnaId) => `${EDIT_APP_QNA_DRAFT_PREFIX}${qnaId}`

export const readAppQnaDraft = (draftKey) => {
    const storage = getSessionStorage()

    if (!storage || !draftKey) {
        return null
    }

    try {
        const storedValue = storage.getItem(draftKey)
        return storedValue ? JSON.parse(storedValue) : null
    } catch (_error) {
        return null
    }
}

export const saveAppQnaDraft = (draftKey, draftValue) => {
    const storage = getSessionStorage()

    if (!storage || !draftKey) {
        return
    }

    try {
        storage.setItem(draftKey, JSON.stringify(draftValue))
    } catch (_error) {
        // sessionStorage가 막혀 있어도 답변 작성 흐름은 그대로 유지한다.
    }
}

export const clearAppQnaDraft = (draftKey) => {
    const storage = getSessionStorage()

    if (!storage || !draftKey) {
        return
    }

    try {
        storage.removeItem(draftKey)
    } catch (_error) {
        // storage 정리에 실패해도 화면 동작은 계속 진행한다.
    }
}
